import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import BrandCreateCompanyComponent from '../../components/Brand/Common/BrandCreateCompanyComponent';
import { useGlobalState } from '../../store/state';

const CreateCompanyPage = () => {
  const [company] = useGlobalState('company');
  const [user] = useGlobalState('user');

  const history = useHistory();
  useEffect(() => {
    if (!user?.opt_verified) {
      history.push('/brand/validate-otp');
    } else if (company.selected) {
      history.push('/brand/'+company.selected.id);
    }
  }, [company.selected]);
  return (
    <div className="signup_wrapper">
      <div className="container-fluid vh-100 px-0">
        <div className="d-flex align-items-center">
          <div className="col-md-6 px-0">
            <div className="signup_wrapper_poster">
              <img src="/images/common/flynt-brand-posters.jpg"
                alt="Otp Poster" />
            </div>
          </div>
          <div className="col-md-6">
            <div>
              <div className="signup_wrapper_content">
                <h4>Create your Company</h4>
                {/* <OtpValidationFormComponent/> */}
                <BrandCreateCompanyComponent redirect="/brand" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateCompanyPage;
